import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../action-creators";
import { selectCacheToken } from "../../selectors/common";
import type { ExportSettingsSourceType, SalesforcePreDefinedType } from "../../type";

export const getSfExcludeStatusFieldsThunk =
    ({
        columnName,
        isPreDefined = false,
        sourceType,
        type,
    }: {
        columnName: string;
        isPreDefined: boolean;
        sourceType: ExportSettingsSourceType;
        type: SalesforcePreDefinedType;
    }) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            const cacheToken = selectCacheToken(getState());

            dispatch(managementActions.salesforce.getExcludeStatusFieldsAsync.request());
            let response = undefined;

            if (isPreDefined) {
                response = await deps.si.api.management.getSfPreDefinedColumns(type, cacheToken);
            } else {
                response = await deps.si.api.management.getSfFields(columnName, type, cacheToken, sourceType);
            }

            dispatch(managementActions.salesforce.getExcludeStatusFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.getExcludeStatusFieldsAsync.failure(error));
        }
    };

export const getSfExclusionFilterStatusThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.getIntegrationLeadFilterStatusAsync.request());

            const { value } = await deps.si.api.management.getExclusionFilterStatus();

            dispatch(managementActions.salesforce.getIntegrationLeadFilterStatusAsync.success(value));
        } catch (error) {
            dispatch(managementActions.salesforce.getIntegrationLeadFilterStatusAsync.failure(error));
        }
    };

export const getSfExcludeAccountFieldsThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.getExcludeAccountFieldsAsync.request());

            const response = await deps.si.api.management.getSfExcludeAccountFields();
            dispatch(managementActions.salesforce.getExcludeAccountFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.salesforce.getExcludeAccountFieldsAsync.failure(error));
        }
    };

export const putSfExcludeThunk =
    (payload: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.salesforce.putIntegrationLeadFilterStatusAsync.request());

            const {
                crmConnectionStatus: { isLeadsFilterEnabled },
            } = await deps.si.api.management.putSfIntegrationLeadFilterStatus(payload);

            dispatch(managementActions.salesforce.putIntegrationLeadFilterStatusAsync.success(isLeadsFilterEnabled));
        } catch (error) {
            dispatch(managementActions.salesforce.putIntegrationLeadFilterStatusAsync.failure(error));
        }
    };
